"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseSpacing;

function parseSpacing(spacings, availableSizes) {
  let spacingsArr = spacings; // If you don't provide any spacing at all,
  // it should do nothing.

  if (!spacings || !spacingsArr.length) {
    return {};
  } // If it isn't an array we want to convert it to an
  // array for easier handling.


  if (!Array.isArray(spacings)) {
    const trimmedSpacing = spacings.trim(); // If it's the string shorthand (e.g. "small 0 0 0"):

    if (trimmedSpacing.includes(' ')) {
      spacingsArr = trimmedSpacing.split(' ').filter(Boolean).map(size => size === '0' ? null : size); // If it's a single size (e.g. "small")
    } else {
      spacingsArr = [trimmedSpacing];
    }
  } // Filter out any values that aren't valid sizes.


  const validSpacingsArr = spacingsArr.map(spacingStr => {
    if (availableSizes.includes(spacingStr) || spacingStr === null) {
      return spacingStr;
    } // eslint-disable-next-line no-console


    console.warn(`"${spacingStr}" is not a valid size and will be ignored. You can use one of ${availableSizes.map(s => `"${s}"`)} or null.`); // eslint-disable-line no-console

    return null;
  });

  if (validSpacingsArr.length > 4) {
    // eslint-disable-next-line no-console
    console.warn('Looks like an invalid spacing argument provided. Expected a string or an array of max 4 items. Provided:'); // eslint-disable-line no-console

    console.warn(spacings); // eslint-disable-line no-console
  }

  switch (validSpacingsArr.slice(0, 4).length) {
    case 1:
      return {
        all: validSpacingsArr[0]
      };

    case 2:
      return {
        vertical: validSpacingsArr[0],
        horizontal: validSpacingsArr[1]
      };

    case 3:
      return {
        top: validSpacingsArr[0],
        horizontal: validSpacingsArr[1],
        bottom: validSpacingsArr[2]
      };

    case 4:
      return {
        top: validSpacingsArr[0],
        right: validSpacingsArr[1],
        bottom: validSpacingsArr[2],
        left: validSpacingsArr[3]
      };

    default:
      return {};
  }
}